import { render, staticRenderFns } from "./PublicPageLayout.vue?vue&type=template&id=ccd821b6&"
import script from "./PublicPageLayout.vue?vue&type=script&lang=js&"
export * from "./PublicPageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports